import React from "react";
import SellerLayout from "./SellerLayout";
import { FaBox, FaShoppingCart, FaRupeeSign } from "react-icons/fa";

const SellerDashboard = () => {
    return (
        <>
            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white rounded-xl shadow p-6">
                    <div className="flex items-center justify-between">
                        <h3 className="text-gray-500">Total Products</h3>
                        <FaBox className="text-indigo-600 text-xl" />
                    </div>
                    <p className="text-3xl font-bold mt-3">120</p>
                </div>

                <div className="bg-white rounded-xl shadow p-6">
                    <div className="flex items-center justify-between">
                        <h3 className="text-gray-500">Total Orders</h3>
                        <FaShoppingCart className="text-green-600 text-xl" />
                    </div>
                    <p className="text-3xl font-bold mt-3">56</p>
                </div>

                <div className="bg-white rounded-xl shadow p-6">
                    <div className="flex items-center justify-between">
                        <h3 className="text-gray-500">Revenue</h3>
                        <FaRupeeSign className="text-yellow-600 text-xl" />
                    </div>
                    <p className="text-3xl font-bold mt-3">₹78,500</p>
                </div>
            </div>

            {/* Recent Orders */}
            <div className="bg-white rounded-xl shadow p-6">
                <h2 className="text-xl font-semibold mb-4">Recent Orders</h2>

                <table className="w-full text-left">
                    <thead>
                        <tr className="text-gray-500 border-b">
                            <th className="py-2">Order ID</th>
                            <th>Status</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="border-b">
                            <td className="py-3">#ORD123</td>
                            <td className="text-green-600">Delivered</td>
                            <td>₹1,200</td>
                        </tr>
                        <tr>
                            <td className="py-3">#ORD124</td>
                            <td className="text-yellow-600">Processing</td>
                            <td>₹850</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default SellerDashboard;
